<template>
	<layout-page title="Paper Market">
		<!-- title -->
		<div
			class="bg-green px-6 py-4 md:rounded-tl-2xl xl:rounded-t-2xl flex justify-start items-center"
		>
			<h1 class="text-4xl font-semibold text-white">
				{{ __("Paper market") }}
			</h1>
		</div>

		<!-- control/filter bar -->
		<paper-filter
			v-model="filter"
			:filter="filter"
			:filter-options="filterOptions"
			:my-offers-count="myOffersCount"
			:offers="{ sell: offersSell, buy: offersBuy }"
		/>

		<!-- offers -->
		<div
			class="px-4 sm:px-6 lg:px-6 py-6 bg-gray-100 flex-grow flex md:space-x-6"
		>
			<paper-offers
				key="sell"
				trade="sell"
				class="w-full md:w-1/2"
				:class="{ 'hidden md:block': showSellerOnMobile }"
				:offers="offersSell"
				:success="success"
				:filter-options="filterOptions"
				:active-futures="activeFutures"
				v-on:toggle-show-results-on-mobile="toggleShowResultsOnMobile"
			/>
			<paper-offers
				key="buy"
				trade="buy"
				class="w-full md:w-1/2"
				:class="{ 'hidden md:block': !showSellerOnMobile }"
				:offers="offersBuy"
				:success="success"
				:filter-options="filterOptions"
				:active-futures="activeFutures"
				v-on:toggle-show-results-on-mobile="toggleShowResultsOnMobile"
			/>
		</div>
	</layout-page>
</template>

<script>
let options = require("../cropOptions");
import UiFilterSessionStorage from "../components/Ui/FilterSessionStorage.vue";

export default {
	mixins: [UiFilterSessionStorage],
	props: {
		activeFutures: {
			type: Array,
			required: true,
		},
		offersBuy: {
			type: Array,
			required: true,
		},
		offersSell: {
			type: Array,
			required: true,
		},
		user: {
			type: Object,
			required: true,
		},
		success: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		let filterOptions = {
				locationHubs: options.getPaperHubs(),
			},
			allPaperGrades = filterOptions.locationHubs.flatMap((h) =>
				Object.keys(h.productGradeOptions)
			),
			allProductGradeOptions = Object.values(
				options.productGradeOptions
			).flat();

		filterOptions.productGrades = allProductGradeOptions.filter((g) =>
			allPaperGrades.includes(g.id)
		);

		filterOptions.productYears = options.harvestYearOptions.map(function (y) {
			return {
				id: y,
				name: y,
				checked: false,
			};
		});

		filterOptions.mine = 0;

		Object.keys(filterOptions).forEach(function (field) {
			Object.keys(filterOptions[field]).forEach(function (option) {
				filterOptions[field][option].checked = false;
				filterOptions[field][option].value = filterOptions[field][option].id;
				filterOptions[field][option].label = filterOptions[field][option].name;
			});
		});
		filterOptions.dateType = [
			{
				label: this.__("At harvest"),
				value: "AT_HARVEST",
				checked: false,
			},
			{
				label: this.__("Month"),
				value: "MONTH",
				checked: false,
			},
		];
		filterOptions.monthType = {
			month_from: null,
			month_to: null,
		};

		let productGrades = [];
		allProductGradeOptions
			.filter((g) => allPaperGrades.includes(g.id))
			.forEach((o) => {
				if (o.group && o.default) {
					productGrades.push({
						label: o.group,
						value: o.default,
						name: o.name,
						id: o.default,
						checked: false,
					});
				} else if (o.group) {
				} else {
					productGrades.push({
						label: o.name,
						value: o.id,
						name: o.name,
						id: o.id,
						checked: false,
					});
				}
			});
		filterOptions.productGrades = productGrades;
		return {
			//isLoading: false,
			filter: Vue.observable({
				locationHubs: [],
				productGrades: [],
				productYears: [],
				mine: 0,
				dateType: [],
				monthType: {
					month_from: null,
					month_to: null,
				},
			}),
			filterOptions: filterOptions,
			showListOnMobile: false,
			showSellerOnMobile: false,
			delayedFutures: [],
		};
	},
	computed: {
		meta() {
			return this.user;
		},
		myOffersCount() {
			return (
				(this.offersBuy || []).filter((o) => o.mine).length +
				(this.offersSell || []).filter((o) => o.mine).length
			);
		},
		offersCount() {
			return {
				sell: (this.offersSell || []).length,
				buy: (this.offersBuy || []).length,
			};
		},
	},
	methods: {
		async fetchFutures() {
			// optionally poll for updates in the future TODO
			let req = await axios.get(window.baseUrl + "/paper/futures");
			this.delayedFutures = req.data.data;
		},
		toggleShowResultsOnMobile(newVal) {
			this.showSellerOnMobile = !this.showSellerOnMobile;
		},
	},
};
</script>
